var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.268,
    height: 20.854,
    viewBox: "0 0 26.268 20.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bxl-medium",
    d: "M6.17,10.551a1.015,1.015,0,0,0-.332-.857L3.386,6.739V6.3H11l5.887,12.909L22.063,6.3h7.259v.442l-2.1,2.009a.623.623,0,0,0-.233.588V24.11a.621.621,0,0,0,.233.588l2.049,2.009v.442h-10.3v-.442l2.117-2.06c.211-.208.211-.27.211-.587V12.118L15.4,27.1h-.8L7.737,12.118v10.04a1.387,1.387,0,0,0,.381,1.153l2.759,3.349V27.1H3.054v-.442l2.759-3.347A1.344,1.344,0,0,0,6.17,22.16Z",
    transform: "translate(-3.054 -6.296)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.0a2c940f0b9ca9c7bc93777865a0b110.svg";
export { ForwardRef as ReactComponent };